import { useEffect, useMemo, useState } from "react";
import axios from "axios";

// Sugestões de um lugar do cardápio (sacola, adicionado, checkout), já como produtos do
// cardápio. Produto com opções fica de fora quando `somenteSimples` (checkout: 1 toque).
export function ehSimples(produto) {
  return !!produto && produto.product_type !== "combo" && produto.product_type !== "pizza"
    && !(produto.order_steps && produto.order_steps.length);
}

export function useSugestoes({ ativo, lugar, carrinhoIds, base = null, ofertasIds = [], produtosPorId, somenteSimples = false }) {
  const [resposta, setResposta] = useState([]);
  const chaveCarrinho = (carrinhoIds || []).join(",");
  const chaveOfertas = (ofertasIds || []).join(",");

  useEffect(() => {
    if (!ativo || !chaveCarrinho) { setResposta([]); return undefined; }
    let vivo = true;
    const timer = setTimeout(() => {
      axios.get("/api/public/sugestoes", { params: { lugar, carrinho: chaveCarrinho, base: base || undefined, ofertas: chaveOfertas || undefined } })
        .then(({ data }) => { if (vivo) setResposta(data?.sugestoes || []); })
        .catch(() => { if (vivo) setResposta([]); });
    }, 250);
    return () => { vivo = false; clearTimeout(timer); };
  }, [ativo, lugar, chaveCarrinho, base, chaveOfertas]);

  return useMemo(() => {
    const noCarrinho = new Set(carrinhoIds || []);
    return resposta
      .map((s) => ({ ...s, produto: produtosPorId?.get(String(s.id)) }))
      .filter((s) => s.produto && s.produto.available !== false && !noCarrinho.has(String(s.id)))
      .filter((s) => !somenteSimples || ehSimples(s.produto));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resposta, produtosPorId, chaveCarrinho, somenteSimples]);
}
